<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="shipments")
    modal-shipments(:form='form', :is-add='isModalAdd')
    modal-tracking-guides(:form='form')
    modal-tracking-guide-files(:form='form')
    modal-complete-shipment(:form='form')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.shipments') }}:
            span {{ $t('strings.description', {attribute: $t('strings.shipments')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(v-if="$auth.check('Admin') || $auth.check('Agente Aduanal')" icon="plus" @click="goCreate") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="exportShipments")
                    vm-icon(icon="download-outline")
                    slot &nbsp;{{ $t('strings.export') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="shipments" )
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                .d-flex.justify-content-between(@click="loadCatalogsFilters()")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('shipments.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        vm-select.filter(:placeholder='$t("strings.multiple")' :label='$t("shipments.status_id")' multiple autocomplete v-model="filters.whereIn.status_id" @change="$emit('filter', filters)")
                          vm-select-item(:key='index', :value='item.id', :text="$t('shipments.'+ item.id)", v-for='item,index in shipmentStatuses')
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('shipments.'+ item)")
                    vm-order-by-item(value='folio,asc' text='Folio' direction='down')
                    vm-order-by-item(value='folio,desc' text='Folio' direction='up')
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('shipments.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  .details(@click="goDetail(data[indextr])")
                    slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'created_at' || column == 'shipment_date' || column == 'arrival_date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'supplier_display' && $auth.check(['Admin', 'Agente Aduanal'])") {{data[indextr]['supplier_display'] }}
                    slot(v-if="column != 'status_id' && column != 'created_at' && column != 'shipment_date' && column != 'arrival_date' && column != 'total' && column != 'unit_price' && column !='supplier_display'") {{data[indextr][column]}}
                    vm-status-indicator(v-if="column == 'status_id'" :pulse="data[indextr]['status_id']" :color="colorStatus(data[indextr]['status_id'])") {{ $t('shipments.'+ data[indextr]['status_id']) }}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="showTrackingGuides(data[indextr], tr)")
                      vm-icon(icon="plus-outline")
                      slot &nbsp;{{ $t('shipments.add_tracking_guide') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin') || $auth.check('Agente Aduanal')" @click="showTrackingGuidesFiles(data[indextr], tr)")
                      vm-icon(icon="menu-arrow-outline")
                      slot &nbsp;{{ $t('strings.tracking_guides') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin') && data[indextr]['status_id'] != 2 && data[indextr]['status_id'] != 3 && data[indextr]['status_id'] != 4 && data[indextr]['status_id'] != 5" @click="cancelShipment(data[indextr])")
                      vm-icon(icon="slash-outline")
                      slot &nbsp;{{ $t('strings.cancel') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin') && data[indextr]['status_id'] != 2 && data[indextr]['status_id'] != 3 && data[indextr]['status_id'] != 4 && data[indextr]['status_id'] != 5" @click="showCancelShipmentModal(data[indextr])")
                      vm-icon(icon="checkmark-circle-outline")
                      slot &nbsp;{{ $t('strings.complete') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == 'Inactivo'" @click="setActionRecord(data[indextr], 'actived')")
                      vm-icon(icon="person-done-outline")
                      slot &nbsp;{{ $t('strings.action_active') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 'Inactivo'" @click="deleteRecordConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Shipments')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalShipments = () => import('@/components/modals/ModalShipments.vue')
const ModalTrackingGuides = () => import('@/components/modals/ModalTrackingGuides.vue')
const ModalTrackingGuideFiles = () => import('@/components/modals/ModalTrackingGuideFiles.vue')
const ModalCompleteShipment = () => import('@/components/modals/ModalCompleteShipment.vue')

export default {
  name: 'ViewShipments',
  components: {
    ModalImport,
    ModalShipments,
    ModalTrackingGuides,
    ModalTrackingGuideFiles,
    ModalCompleteShipment
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    cachingFilters: true,
    cacheKey: 'user_shipments_filters',
    columns: [
      'folio',
      'notes',
      'supplier_display',
      'shipment_date',
      'lead_time',
      'arrival_date',
      'status_id',
      'created_at'
    ],
    columnsOrderBy: ['name', 'email'],
    attributeModal: 'folio',
    status: [
      {
        value: 1,
        color: 'warning'
      },
      {
        value: 2,
        color: 'success'
      },
      {
        value: 3,
        color: 'warning'
      },
      {
        value: 4,
        color: 'success'
      },
      {
        value: 5,
        color: 'danger'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        folio: '',
        shipment_date: '',
        supplier: {
          business_name: ''
        },
        lead_time: '',
        arrival_date: '',
        total_units: '',
        notes: '',
        branch_id: '',
        param: ''
      },
      whereIn: {
        status_id: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  created () {
    if (!this.isSFS) this.columns.splice(7, 0, 'branch_display')
  },
  computed: {
    ...mapGetters(['shipments', 'shipmentStatuses', 'pagination', 'filterParams']),
    ...configMapGetters(['isSFS'])
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'getShipmentStatuses',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'loadTrackingGuides',
      'setModalTrackingGuidesVisible',
      'setModalTrackingGuidesFilesVisible',
      'setModalCompleteShipmentVisible',
      'checkBalanceByShipment'
    ]),
    cancelShipment (record) {
      this.auxCreateRecord = () => {
        this.setActionRecord(record, 'cancel').then(() => {
          setTimeout(() => {
            this.checkBalanceByShipment(record)
          }, 5000)
        })
      }
      this.$vm.dialog({
        color: 'primary',
        title: this.$t('shipments.cancel_confirmation_title'),
        text: this.$t('shipments.cancel_confirmation_text') + ' ' + record.folio,
        accept: this.auxCreateRecord,
        acceptText: this.$t('strings.accept')
      })
    },
    goDetail (record) {
      this.$router.push(`/shipment/${record.id}/detail`)
    },
    goCreate () {
      this.$router.push({ name: 'tab-shipments' })
    },
    showTrackingGuides (record) {
      this.form = record
      this.setModalTrackingGuidesVisible(true)
    },
    showTrackingGuidesFiles (record) {
      this.form = record
      this.loadTrackingGuides({ page: 1, shipment_id: record.id })
      this.setModalTrackingGuidesFilesVisible(true)
    },
    setPaginationModal (value) {
      this.loadTrackingGuides({ page: value.page, shipment_id: value.shipment_id })
    },
    showCancelShipmentModal (record) {
      this.form = record
      this.setModalCompleteShipmentVisible(true)
    },
    exportShipments () {
      this.exportRecords()
    },
    async loadCatalogsFilters () {
      if (this.shipmentStatuses.length === 0) await this.getShipmentStatuses()
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}

</style>
